import React from 'react';

const Contact = () => {
    return(
        <div>
        <section className="page-section" id="contact">
        <div className="container">
            <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Contact Me</h2>
            <div className="divider-custom">
                <div className="divider-custom-line"></div>
                <div className="divider-custom-icon"><i class="fas fa-mobile-alt"></i></div>
                <div className="divider-custom-line"></div>
            </div>

            <div className="row">
                <div className="col-lg-8 mx-auto">
                    <form id="contactForm" name="sentMessage" noValidate="novalidate"  action="https://formspree.io/moqkvdqb" method="POST">
                        <div className="control-group">
                            <div className="form-group floating-label-form-group controls mb-0 pb-2">
                                <label>Name</label><input  type="text" name="name" className="form-control" id="name" placeholder="Name" required="required" data-validation-required-message="Please enter your name." />
                                <p className="help-block text-danger"></p>
                            </div>
                        </div>
                        <div className="control-group">
                            <div className="form-group floating-label-form-group controls mb-0 pb-2">
                                <label>Email Address</label><input className="form-control" name="email" id="email" type="email" placeholder="Email Address" required="required" data-validation-required-message="Please enter your email address." />
                                <p className="help-block text-danger"></p>
                            </div>
                        </div>
                        <div className="control-group">
                            <div className="form-group floating-label-form-group controls mb-0 pb-2">
                                <label>Phone Number</label><input className="form-control" name="mobile" id="phone" type="tel" placeholder="Phone Number" required="required" data-validation-required-message="Please enter your phone number." />
                                <p className="help-block text-danger"></p>
                            </div>
                        </div>
                        <div className="control-group">
                            <div className="form-group floating-label-form-group controls mb-0 pb-2">
                                <label>Message</label><textarea className="form-control" name="description" id="message" rows="5" placeholder="Message" required="required" data-validation-required-message="Please enter a message."></textarea>
                                <p className="help-block text-danger"></p>
                            </div>
                        </div>
                        <br />
                        <div id="success"></div>
                        <div className="form-group"><button className="btn btn-primary btn-xl" id="sendMessageButton" type="submit">Send <i class="far fa-paper-plane"></i></button></div>
                    </form>
                </div>
            </div>
        </div>
    </section>
        </div>
    );
}

export default Contact;